<template>
  <WidgetKpiCard
    :error="!!error"
    :loading="loading"
    :lastUpdate="lastUpdate"
    @click:refresh="refresh"
    @click:table="showTable"
  >
    <template #title>
      {{ $t("widgets.customer.title") }}
    </template>

    <template v-if="data" #main>
      <KpiMain
        :title="$t('widgets.customer.total')"
        :value="
          formatCurrency(data.main.value, {
            formatWithSymbol: false,
            precision: 0
          })
        "
        @click="onMainKpiClick"
      ></KpiMain>
    </template>

    <template v-if="data" #subs>
      <KpiSub
        :title="$t('widgets.common.today')"
        :value="data.subs.today.value"
        :delta="data.subs.today.delta"
        @click="onSubKpiClick('day')"
      ></KpiSub>
      <KpiSub
        :title="$t('widgets.common.yesterday')"
        :value="data.subs.yesterday.value"
        :delta="data.subs.yesterday.delta"
        @click="onSubKpiClick('yesterday')"
      ></KpiSub>
      <KpiSub
        :title="dateNames.month"
        :value="data.subs.month.value"
        :delta="data.subs.month.delta"
        @click="onSubKpiClick('month')"
      ></KpiSub>
      <KpiSub
        :title="dateNames.year"
        :value="data.subs.year.value"
        :delta="data.subs.year.delta"
        @click="onSubKpiClick('year')"
      ></KpiSub>
    </template>
  </WidgetKpiCard>
</template>
<script>
import { inject } from "vue-demi";

import { useWidgetApi } from "@/composables/api/widget";
import { useRouter } from "@/composables/router";
import { usePeriodNames } from "@/composables/date";

import WidgetKpiCard from "./WidgetKpiCard.vue";
import KpiSub from "./WidgetKpiCard/KpiSub.vue";
import KpiMain from "./WidgetKpiCard/KpiMain.vue";
import { formatDate } from "@/utils/date";
import {
  startOfMonth,
  subDays,
  endOfMonth,
  startOfYear,
  endOfYear
} from "date-fns";

export default {
  components: { WidgetKpiCard, KpiSub, KpiMain },

  props: {
    hover: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const { data, lastUpdate, loading, error, refresh } = useWidgetApi(
      "/dashboard/customer"
    );

    const router = useRouter();

    const showTable = () => {
      router.push({ name: "DashboardTable", query: { measure: "customer" } });
    };

    const showOnMap = inject("showOnMap");

    const onMainKpiClick = () => {
      showOnMap({
        measure: "customer"
      });
    };

    const onSubKpiClick = period => {
      const { startDate, endDate } = {
        day: {
          startDate: formatDate(new Date()),
          endDate: formatDate(new Date())
        },
        yesterday: {
          startDate: formatDate(subDays(new Date(), 1)),
          endDate: formatDate(subDays(new Date(), 1))
        },
        month: {
          startDate: formatDate(startOfMonth(new Date())),
          endDate: formatDate(endOfMonth(new Date()))
        },
        year: {
          startDate: formatDate(startOfYear(new Date())),
          endDate: formatDate(endOfYear(new Date()))
        }
      }[period];

      showOnMap({
        measure: "customer",
        date_from: startDate,
        date_end: endDate
      });
    };

    const dateNames = usePeriodNames();

    return {
      data,
      error,
      loading,
      lastUpdate,

      refresh,
      showTable,

      onMainKpiClick,
      onSubKpiClick,

      dateNames
    };
  }
};
</script>
<style></style>
